import React, { useEffect, useState } from 'react'
import FA from 'react-fontawesome'
import {MainHeader} from "reactjs-admin-lte";

const roleToDisplayString = (role, roles, supplierIds, supplierPortalIds, carrierId) => {
    console.log("role to display text:", role);

    const formatPlantId = (plantId) => {
        switch(plantId){
            case "0220": return "Uki";
            case "0300": return "Salo";
            case "0330": return "Uki EV";
            default: return plantId;
        }
    }

    const distinct = (value, index, self) => {
        return self.indexOf(value) === index;
    }

    const vaSupplierPortalPlants = (roles) => {
        return roles.filter(r => r.startsWith("VASupplierPortal")).map(r => r.slice(-4)).filter(distinct)
    }

    switch (role) {
        case "Admin": return "Admin";
        case "VAMaterialPlanner": return "Material planner";
        case "VATransportPlanner": return "Transportation planner";
        case "VAPackageForwarding": return "Package forwarding";
        case "VAPackagePlanner": return "Package planner";
        case "VAForwarding": return "Forwarding";
        case "VAForkliftOperator": return "Forklift Operator";
        case "VAInternalLogistics": return "Internal logistics";
        case "VASupplierPortal0220": return `Supplier Portal (${vaSupplierPortalPlants(roles)})`;
        case "VASupplierPortal0300": return `Supplier Portal (${vaSupplierPortalPlants(roles)})`;
        case "VASupplierPortal0330": return `Supplier Portal (${vaSupplierPortalPlants(roles)})`;
        case "VASupplierPortalAdmin0220": return `Supplier Portal (${vaSupplierPortalPlants(roles)})`;
        case "VASupplierPortalAdmin0300": return `Supplier Portal (${vaSupplierPortalPlants(roles)})`;
        case "VASupplierPortalAdmin0330": return `Supplier Portal (${vaSupplierPortalPlants(roles)})`;
        case "Supplier": return `Supplier (${supplierIds})`;
        case "PortalSupplier": return `Portal Supplier (${supplierPortalIds.map(portalId => `${formatPlantId(portalId.plantId)}/${portalId.supplierId}`)})`;
        case "ControlTower": return `Control tower (${carrierId})`;
        case "Carrier": return `Carrier (${carrierId})`;
        case "YardOperator": return "Yard operator";
        case "SKDDistribution": return "SKD distribution";
    }
    return "-";
};

const rolePriority = (role) => {
    switch (role) {
        case "Admin": return 0;
        case "VAMaterialPlanner": return 1;
        case "VATransportPlanner": return 1;
        case "VAPackageForwarding": return 1;
        case "VAPackagePlanner": return 1;
        case "VAForwarding": return 1;
        case "VAForkliftOperator": return 1;
        case "VAInternalLogistics": return 1;

        case "Supplier": return 2;
        case "PortalSupplier": return 2;
        case "ControlTower": return 2;
        case "Carrier": return 3;
        case "YardOperator": return 4;
        case "SDKDistribution": return 4;
    }
    return 10;
};

const selectRoleWithMostPriority = (roles, supplierIds, supplierPortalIds, carrierId) => {
    if (roles === undefined) return "";
    const rs = roles.map(role => ({role, priority: rolePriority(role)}));
    rs.sort();
    return rs[0] && roleToDisplayString(rs[0].role, rs.map(r => r.role), supplierIds, supplierPortalIds, carrierId);
};

const getLogoutUrl = () => {
    if(window.VA_ENV === 'LOCAL') {
        return "http://localhost:8180/auth/realms/vatrp/protocol/openid-connect/logout?redirect_uri=http%3A%2F%2Flocalhost:9090%2Ftrp%2Fauth%2Flogout"
    } else if(window.VA_ENV === 'TEST') {
        return "http://vafic81-65.va.local/auth/realms/VATRP/protocol/openid-connect/logout?redirect_uri=http%3A%2F%2Fvafic81-65.va.local%2Ftrp%2Fauth%2Flogout"
    } else {
        return "/auth/realms/VATRP/protocol/openid-connect/logout?redirect_uri=https%3A%2F%2Fvatg.valmet-automotive.com%2Ftrp%2Fauth%2Flogout"
    }
}

const makeUserMenu = (username, roles, supplierIds, supplierPortalIds, carrierId) => {
    if (username) {
        return <ul className="nav navbar-nav ml-auto">
            <li className="nav-item username">
                <a href="#">
                    <span>{selectRoleWithMostPriority(roles, supplierIds, supplierPortalIds, carrierId)}</span>
                </a>
            </li>
            <li className="nav-item username">
                <a href="#">
                    <FA name="user" className="va user-icon"/>
                    <span>{username}</span>
                </a>
            </li>
            <li className="nav-item">
                <a href={getLogoutUrl()}><FA name="sign-out"/></a>
            </li>
        </ul>
    } else {
        return <ul className="nav navbar-nav"/>
    }
};

const appTitle = (applicationName) =>  {
    if (window.VA_ENV){
        return <span className="va app-title">{`Environment: ${window.VA_ENV}${applicationName && ' - ' + applicationName}`}</span>;
    } else {
        return <span className="va app-title">{applicationName}</span>
    }
};

const useLocalStorage = (key, initialValue) => {
    const [value, setValue] = useState(() => {
        const storedValue = localStorage.getItem(key);
        return storedValue ?
            JSON.parse(storedValue) :
            initialValue;
    });

    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);

    return [value, setValue];
}

const MessageBox = ({dismiss}) => (<div className="notification">
    <h4>NOTE!</h4>

    <p>
        Ioncor no longer uses VATRP, instead for Ioncor use
        go to ICTRP <a href="https://ictrp.ioncor-batteries.com">here</a>.
    </p>

    <button onClick={dismiss}>Dismiss</button>
</div>);

export default ({username, roles, supplierIds, supplierPortalIds, carrierId, applicationName}) => {
    const [dismissed, setDismissed] = useLocalStorage("ictrp-notif-dismiss", false);

    const usermenu = makeUserMenu(username, roles, supplierIds, supplierPortalIds, carrierId);

    return <MainHeader>
        <MainHeader.Logo href={"/trp/"} className="va logo">
            <MainHeader.Logo.Mini><b>VA</b></MainHeader.Logo.Mini>
            <MainHeader.Logo.Large><b>Valmet Automotive</b></MainHeader.Logo.Large>
        </MainHeader.Logo>
        <MainHeader.Navbar>
            <MainHeader.SidebarToggle />
            {!dismissed
                ? (<>
                    <MessageBox dismiss={() => setDismissed(true)} />
                    <button className="header-notification-button" onClick={() => setDismissed(!dismissed)}>IONCOR Note!</button>
                </>)
                : <button className="header-notification-button" onClick={() => setDismissed(!dismissed)}>IONCOR Note!</button>
            }
            {appTitle(applicationName)}
            {usermenu}
        </MainHeader.Navbar>
    </MainHeader>
}
